import store from '../../store'
import { fetchEmailVerificationPrompts } from '../../actions/emailVerification'

// whether a prompt is due rarely changes, so this only needs to catch long
// sessions crossing a remind-later window — default to 1 hour if not set or invalid
const interval =
  parseInt(process.env.REACT_APP_EMAIL_VERIFICATION_POLLING_INTERVAL_IN_MS, 10) || 3600000

// when a backgrounded tab comes back, refresh if the last poll is at least
// this old, so returning to a tab left open overnight doesn't wait up to an
// hour — without refetching on every quick tab switch
const MIN_MS_BETWEEN_VISIBILITY_POLLS = 5 * 60 * 1000

let intervalId = null
let lastPolledAt = 0

function poll() {
  const userId = store.getState().user.id
  if (userId) {
    lastPolledAt = Date.now()
    store.dispatch(fetchEmailVerificationPrompts(userId))
  }
}

function handleVisibilityChange() {
  if (document.visibilityState !== 'visible') return
  if (Date.now() - lastPolledAt < MIN_MS_BETWEEN_VISIBILITY_POLLS) return
  poll()
}

export function startEmailVerificationPromptsPolling() {
  if (intervalId) return // already polling

  poll()
  intervalId = setInterval(poll, interval)
  document.addEventListener('visibilitychange', handleVisibilityChange)
}

export function stopEmailVerificationPromptsPolling() {
  if (intervalId) {
    clearInterval(intervalId)
    intervalId = null
    document.removeEventListener('visibilitychange', handleVisibilityChange)
  }
}
